var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import { forwardRef } from "react";
import { Box } from "@mui/material";
import { getTimeElapsedInStopWatchFormatString } from "../helpers/GetTimeElapsedFormatted.helper";
var Accordion = styled(function (props) { return _jsx(MuiAccordion, __assign({ disableGutters: true, elevation: 0, square: true }, props)); })(function (_a) {
    var theme = _a.theme;
    return ({
        border: "1px solid ".concat(theme.palette.divider),
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
    });
});
var AccordionSummary = styled(function (props) { return (_jsx(MuiAccordionSummary, __assign({ expandIcon: _jsx(ArrowForwardIosSharpIcon, { sx: { fontSize: "0.9rem" } }) }, props))); })(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "rgba(0, 0, 0, .03)",
        flexDirection: "row-reverse",
        "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
            transform: "rotate(90deg)",
        },
        "& .MuiAccordionSummary-content": {
            marginLeft: theme.spacing(1),
        },
    });
});
var AccordionDetails = styled(MuiAccordionDetails)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(2),
        borderTop: "1px solid rgba(0, 0, 0, .125)",
    });
});
export default forwardRef(function (_a, ref) {
    var title = _a.title, questionTimeInMilliseconds = _a.questionTimeInMilliseconds, sx = _a.sx, children = _a.children;
    var _b = __read(React.useState("panel1"), 2), expanded = _b[0], setExpanded = _b[1];
    var handleChange = function (panel) { return function (event, newExpanded) {
        setExpanded(newExpanded ? panel : false);
    }; };
    return (_jsxs(Accordion, __assign({ ref: ref, sx: __assign({}, sx), expanded: expanded === "panel1", onChange: handleChange("panel1") }, { children: [_jsx(AccordionSummary, __assign({ "aria-controls": "panel1d-content", id: "panel1d-header" }, { children: _jsxs(Box, __assign({ component: "div", sx: { display: "flex", justifyContent: "space-between", width: "100%" } }, { children: [_jsx(Typography, { children: title }), questionTimeInMilliseconds && (_jsx(Box, __assign({ component: "div", sx: { display: "inline", fontFamily: "Digit" } }, { children: "".concat(getTimeElapsedInStopWatchFormatString(questionTimeInMilliseconds)) })))] })) })), _jsx(AccordionDetails, { children: children })] })));
});
